export default __webpack_public_path__ + "static/media/collected_coin_low.7f9ce70f.wav";